import { createSlice } from '@reduxjs/toolkit';

const userNewsSlice = createSlice({
  name: 'userNews',
  initialState: {
    news: [],
    loading: false,
    error: null,
    showModal: false,
    currentNews: null,
  },
  reducers: {
    requestUserNews: (state) => {
      state.loading = true;
      state.error = null;
    },
    hydrateUserNews: (state, action) => {
      state.news = action.payload;
      state.loading = false;
      state.error = null;
    },
    setUserNewsError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    showUserNewsModal: (state, action) => {
      state.showModal = true;
      state.currentNews = action.payload;
    },
    hideUserNewsModal: (state) => {
      state.showModal = false;
      state.currentNews = null;
    },
    markNewsAsRead: (state, action) => {
      const newsId = action.payload;
      const newsIndex = state.news.findIndex(n => n.id === newsId);
      if (newsIndex >= 0) {
        state.news[newsIndex].viewed = true;
      }
    },
  },
});

export const {
  requestUserNews,
  hydrateUserNews,
  setUserNewsError,
  showUserNewsModal,
  hideUserNewsModal,
  markNewsAsRead,
} = userNewsSlice.actions;

export default userNewsSlice.reducer; 